export interface ParsedQueryString {
  [name: string]: string
}

export function parseQueryString(queryString: string): ParsedQueryString {
  const query: ParsedQueryString = {}
  if (queryString === undefined || queryString.length === 0) {
    return query
  }
  const pairs = (queryString[0] === '?'
    ? queryString.substr(1)
    : queryString
  ).split('&')
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
  }
  return query
}

export function getQueryParameters(): ParsedQueryString {
  const url = window.location.href
  const query = url.split('?')[1]
  return parseQueryString(query)
}

export function createQueryString(queryData: ParsedQueryString): string {
  return Object.keys(queryData)
    .map(key => `${key}=${queryData[key]}`)
    .join('&')
}
